import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  ModalOverlay,
  ModalCard,
  MessageWrapper,
  MessageText,
  ButtonContainer,
  CancelButton,
  DeleteButton,
} from './LockerDeleteModalStyled';

const LockerDeleteModal = ({ open, setOpen, handleDelete }) => {
  const { t } = useTranslation();

  const deleteData = async () => {
    await handleDelete();
    setOpen(false);
  };

  return (
    <ModalOverlay open={open}>
      <ModalCard>
        <MessageWrapper>
          <MessageText>{t('Do you want to delete the locker?')}</MessageText>
        </MessageWrapper>

        <ButtonContainer>
          <CancelButton onClick={() => setOpen(false)}>{t('Cancel')}</CancelButton>
          <DeleteButton onClick={() => deleteData()}>{t('Save')}</DeleteButton>
        </ButtonContainer>
      </ModalCard>
    </ModalOverlay>
  );
};

export default LockerDeleteModal;
